import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=52ef7f16&"
import script from "./SecuritySetting.vue?vue&type=script&lang=ts&"
export * from "./SecuritySetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports